/* eslint-disable react/no-unused-prop-types */
import { Component } from 'react';
import PropTypes from 'prop-types';
import handleInputChange from '%/utils/handleInputChange';
import { getPayload } from '%/utils/forms/getPayload';
import { handleUsedVehicleParams } from '%/utils/forms/handleUsedVehicleParams';
import validationFactory from '%/utils/validation';
import { mask } from '%/utils/formUtils/maks/mask';
import FormWrapper from '../FormComponents/FormWrapper';
import FormHeader from '../FormComponents/FormHeader';
import FormBody from '../FormComponents/FormBody';
import FieldGroup from '../FormComponents/FieldGroup';
import Input from '../FormComponents/Fields/Input';
import Checkbox from '../FormComponents/Fields/Checkbox';
import Select from '../FormComponents/Fields/Select';
import FormFooter from '../FormComponents/FormFooter';
import SubmitButton from '../FormComponents/SubmitButton';
import ContactFieldGroup from '../FormComponents/Fields/ContactFieldGroup';
import FormMessageOverlay from '../../FormMessageOverlay';
import Textarea from '../FormComponents/Fields/Textarea';

export default class UsedVehicleForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: null,
      email: null,
      phone: null,
      message: null,
      cpf: '',
      unit:
        props.units && props.units.length === 1
          ? props.units[0]
          : props.unit || null,
      mailing: null,
      whatsapping: null,
      phoning: null,
      dataPermissions: false,
      formState: {
        isSubmitting: false,
        errorSending: false,
        showOverlay: false,
      },
    };

    this.handleInputChange = handleInputChange.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (this.phoneInput) {
      mask(this.phoneInput, { mask: 'phone' }, phoneMaskvalue =>
        this.setState({ phone: phoneMaskvalue }),
      );
    }

    if (this.cpfInput) {
      mask(this.cpfInput, { mask: 'cpf' }, cpfMaskValue =>
        this.setState({ cpf: cpfMaskValue }),
      );
    }

    this.validator = validationFactory(`#${this.props.formId}`);
  }

  handleCloseOverlay() {
    this.setState({ formState: { showOverlay: false } });
  }

  handleSubmit(event) {
    event.preventDefault();

    const invalidInputs = this.validator.validateAll(this.form);
    const formIsValid = invalidInputs.length === 0;
    if (!formIsValid) return;

    const payload = getPayload(this.state, this.props, handleUsedVehicleParams);

    this.setState({
      formState: { isSubmitting: true },
    });

    window.serviceConversion
      .convert(payload)
      .then(() => {
        this.setState({
          formState: {
            isSubmitting: false,
            errorSending: false,
          },
        });
        return {
          data: payload,
          status: 'success',
        };
      })
      .catch(error => {
        this.setState({
          formState: {
            isSubmitting: false,
            errorSending: true,
          },
        });
        console.error(error);
        return {
          data: error,
          status: 'error',
        };
      })
      .then(result => {
        document.dispatchEvent(
          new CustomEvent('new_conversion', {
            detail: {
              status: result.status,
              data: result.data,
            },
          }),
        );
        this.setState({
          formState: { showOverlay: true },
        });
      });
  }

  render() {
    const {
      formId,
      showCpf,
      showUnits,
      shouldShowDataPermissions,
      dataPermissionsCustomText,
      linkPrivacyPolicy,
      buttonLabel,
      showMessageInput,
      title,
      subtitle,
    } = this.props;

    return (
      <FormWrapper
        customClasses="conversion-form--new-vehicle"
        formId={formId}
        setRef={form => {
          this.form = form;
        }}
        handleSubmit={this.handleSubmit}
      >
        <FormMessageOverlay
          handleClose={this.handleCloseOverlay}
          isVisible={this.state.formState.showOverlay}
          type={this.state.formState.errorSending ? 'error' : 'success'}
        />
        <FormHeader title={title} subtitle={subtitle} />
        <FormBody>
          <FieldGroup>
            <Input
              title="Nome"
              name="name"
              value={this.state.name}
              type="text"
              placeholder="Nome"
              handleChange={this.handleInputChange}
              required
            />
            <Input
              title="E-mail"
              name="email"
              value={this.state.email}
              type="email"
              placeholder="E-mail"
              handleChange={this.handleInputChange}
              required
            />
            <Input
              title="Telefone"
              name="phone"
              value={this.state.phone}
              type="phone"
              autoComplete="off"
              placeholder="Telefone/Whatsapp"
              handleChange={this.handleInputChange}
              setRef={phoneInput => {
                this.phoneInput = phoneInput;
              }}
              required
            />
            {showMessageInput && (
              <Textarea
                title="Mensagem"
                name="message"
                value={this.state.message}
                placeholder="Mensagem"
                handleChange={this.handleInputChange}
                maxLength={255}
              />
            )}
            {showCpf && (
              <Input
                title="CPF"
                name="cpf"
                value={this.state.cpf}
                type="text"
                placeholder="CPF"
                handleChange={this.handleInputChange}
                setRef={cpfInput => {
                  this.cpfInput = cpfInput;
                }}
                required
                minLength={14}
              />
            )}
            {showUnits && (
              <Select
                name="unit"
                options={this.props.units}
                label="Escolha a unidade:"
                placeholder="Selecione uma unidade"
                handleChange={this.handleInputChange}
              />
            )}
          </FieldGroup>
          <ContactFieldGroup
            handleChange={this.handleInputChange}
            mailing={this.state.mailing}
            whatsapping={this.state.whatsapping}
            phoning={this.state.phoning}
          />
          {shouldShowDataPermissions && (
            <FieldGroup>
              <Checkbox
                label={dataPermissionsCustomText}
                name="dataPermissions"
                value={this.state.dataPermissions}
                isChecked={this.state.dataPermissions}
                customClasses="form__field-checkbox-data-permissions"
                handleChange={this.handleInputChange}
              />
            </FieldGroup>
          )}
          <FormFooter linkPrivacyPolicy={linkPrivacyPolicy} />
          <SubmitButton
            label={buttonLabel}
            isSubmitting={this.state.formState.isSubmitting}
          />
        </FormBody>
      </FormWrapper>
    );
  }
}

UsedVehicleForm.defaultProps = {
  title: 'Estou Interessado',
  subtitle:
    'Preencha o formulário abaixo para receber o contato de um de nossos especialistas:',
  buttonLabel: 'Estou interessado',
  showMessageInput: true,
};

UsedVehicleForm.propTypes = {
  formId: PropTypes.string,
  linkPrivacyPolicy: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  unit: PropTypes.string,
  product: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  country: PropTypes.string,
  showCpf: PropTypes.bool,
  showUnits: PropTypes.bool,
  contactsWithDynamicRequired: PropTypes.bool,
  shouldShowDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  showLocationFields: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonLabel: PropTypes.string,
  showMessageInput: PropTypes.bool,
};
